module.exports = __webpack_public_path__ + "img/practitioner-avatar.e467051.svg";